import React from "react";
import { StaffLoginData } from "../Api/Staff";

interface UserObjectInterface {
    seed?: string;
    stfId?: number | null;
    stfName?: string | null;
    stfAccessList: Array<string>;
}

const initialState: UserObjectInterface = {
    stfAccessList: [],
}

type Action =
    | { type: 'setSeed', payload: string }
    | {
        type: 'setUser',
        payload: StaffLoginData
    }
    | { type: 'unsetUser' }


export const UserObjectStore = React.createContext({} as {
    userObjectState: UserObjectInterface,
    userObjectDispatch: React.Dispatch<Action>
})

const reducer = (dataState: UserObjectInterface, action: Action): UserObjectInterface => {
    switch (action.type) {
        case 'setSeed':
            return {
                ...dataState,
                seed: action.payload
            }
        case 'setUser':
            return {
                ...dataState,
                stfId: action.payload.stf_id,
                stfName: action.payload.stf_name,
                stfAccessList: action.payload.stf_access_list
            }
        case 'unsetUser':
            return initialState
        default:
            throw new Error()
    }
}

export const UserObjectProvider = (props: React.PropsWithChildren<{}>) => {
    const [userObjectState, userObjectDispatch] = React.useReducer<React.Reducer<UserObjectInterface, Action>>(reducer, initialState)
    return (
        <UserObjectStore.Provider value={{ userObjectState, userObjectDispatch }} {...props} />
    )
}